export var getTabButtonID = function getTabButtonID(name) {
  return "tabs-" + name + "-button";
};
export var getTabPanelID = function getTabPanelID(name) {
  return "tabs-" + name + "-tab";
};